export default {
  title: {
    id: 'buyback_swap_offer_title',
    defaultMessage: 'Top offer: {price}',
  },
  opener: {
    id: 'buyback_swap_offer_opener',
    defaultMessage: 'Abracadabra!',
  },
  contentFirst: {
    id: 'buyback_swap_offer_content_1',
    defaultMessage:
      'Your {buybackProduct} was matched with a professional refurbisher.',
  },
  contentSecond: {
    id: 'buyback_swap_offer_content_2',
    defaultMessage:
      'You’ll get paid {price} once they receive your device and confirm it matches your assessment.',
  },
  listIntro: {
    id: 'buyback_swap_offer_list_intro',
    defaultMessage: 'Finalize your trade-in',
  },
  firstItemTitle: {
    id: 'buyback_swap_offer_list_item_1_title',
    defaultMessage: 'Finish shopping',
  },
  firstItemDesc: {
    id: 'buyback_swap_offer_list_item_1_desc',
    defaultMessage:
      'Your trade-in value will appear in your cart once you add whatever you’d like to buy.',
  },
  secondItemTitle: {
    id: 'buyback_swap_offer_list_item_2_title',
    defaultMessage: 'Ship your item for free',
  },
  secondItemDesc: {
    id: 'buyback_swap_offer_list_item_2_desc',
    defaultMessage:
      'You’ll have 21 days to transfer your data to another device and ship your trade-in.',
  },
  thirdItemTitle: {
    id: 'buyback_swap_offer_list_item_3_title',
    defaultMessage: 'Enter your banking info to get paid',
  },
  thirdItemDesc: {
    id: 'buyback_swap_offer_list_item_3_desc',
    defaultMessage: 'Get cash money',
  },
  infoBlockTitle: {
    id: 'buyback_swap_offer_info_block_title',
    defaultMessage: 'You crushed {weight} of e-waste',
  },
  infoBlockMessage: {
    id: 'buyback_swap_offer_info_block_message',
    defaultMessage:
      'By giving your {buybackProduct} a new life, you’re keeping electronic waste out of landfills. Nice job, boss.',
  },
  summaryTitle: {
    id: 'buyback_swap_offer_summary_title',
    defaultMessage: 'Your trade-in',
  },
  moreDetails: {
    id: 'buyback_swap_offer_more_details',
    defaultMessage: 'See more details',
  },
  ewasteSmartphone: {
    id: 'buyback_swap_offer_ewaste_smartphone',
    defaultMessage: '178g',
  },
  ewasteTablet: {
    id: 'buyback_swap_offer_ewaste_tablet',
    defaultMessage: '399g',
  },
  ewasteMacbook: {
    id: 'buyback_swap_offer_ewaste_macbook',
    defaultMessage: '1585g',
  },
  ewasteConsole: {
    id: 'buyback_swap_offer_ewaste_console',
    defaultMessage: '3500g',
  },
  ewasteAudio: {
    id: 'buyback_swap_offer_ewaste_audio',
    defaultMessage: '260g',
  },
  faqTitle: {
    id: 'buyback_swap_offer_faq_title',
    defaultMessage: 'Frequently Asked Questions',
  },
}
